import { defineStore, storeToRefs } from 'pinia';

import { useDidShow } from '@eaphone/hooks';
import type { AsyncList, List } from '@eaphone/network/lib';
import { Network } from '@eaphone/network/next.ts';
import type { Device, Resource } from '@eaphone/types/resources';

const fetcher: AsyncList<Resource['family/v1/device'], never> = async () =>
  Network.custom.list('family/v1/device').then(({ list }) => ({
    list,
    page_size: list.length,
    page_index: 1,
    total_record: list.length,
  }));

type Temp = List<Device>;

type State = {
  temp: Temp;
};

export const useDeviceStore = defineStore('device', {
  state: (): State => ({
    temp: {
      list: [],
      page_size: 15,
      page_index: 1,
      total_record: 0,
    },
  }),
  getters: {
    count(state: State) {
      return state.temp.list?.length || 0;
    },
    mine(state: State) {
      return (
        state.temp.list.filter((item) => item.role === 'ADMIN')?.length || 0
      );
    },
  },
  actions: {
    async fetchData(): Promise<Temp> {
      return fetcher().then((temp) => {
        this.temp = temp;

        return temp;
      });
    },
  },
});

export function useDevice() {
  const store = useDeviceStore();

  const io = storeToRefs(store);

  useDidShow(store.fetchData);

  return io;
}
